/* Shopify asset note: save this file as `trident-ultra.js.liquid` so the served URL is `trident-ultra.js`. */
(function () {
  if (typeof window === 'undefined') return;
  if (typeof window.gtTrack === 'function') return;

  window.gtTrack = function (name, data) {
    var payload = data || {};
    payload.name = name;
    payload.ts = Date.now();

    try {
      document.dispatchEvent(new CustomEvent('gtLeadMagnetEvent', { detail: payload }));
    } catch (e) {}

    try {
      if (window.dataLayer && Array.isArray(window.dataLayer)) {
        window.dataLayer.push(Object.assign({ event: 'gtLeadMagnetEvent', gt_name: name }, payload));
      }
    } catch (e) {}

    try {
      if (typeof window.gtag === 'function') window.gtag('event', name, payload);
    } catch (e) {}
  };
})();

